module.exports = __webpack_public_path__ + "static/media/inSelectArrowDown.9f67322c.svg";